import React, { createContext, useEffect, useState } from 'react';

import {
  EmptyArea,
  ProfileDropDownHeader,
  // ProfileDropDownUserName,
  SidebarWrapper,
  BurgerMenu,
  // RolesContainer,
  // RolesHeader,
} from './styles';

export const SidebarContext = createContext<boolean>(false);

import { getRedirectToLoginPath } from 'utils/happyFunctions';
import { MenuItem, MenuLink } from 'components/MainHeader/styles';

import { useSelector } from 'react-redux';
import { RootState } from 'store/store';

import BadgeProfileDropdown from '../Dropdown/BadgeProfileDropdown';
import axios from 'axios';
import { IClientItem } from '../../containers/SmsPanel/SmsPanel';
import { getDomainAndPort } from '../../api/Utils';
import { useTranslation } from 'react-i18next';
import { useTour } from '@reactour/tour';
import { MoreAboutCompany } from '../../containers/Tasks/TaskSidebar/styles';
import NavLink from '../NavLink';
import Icon from '../Icon/Icon';
// import { setAddOrUpdateUserFlag } from '../../store/thisUser/thisUserSlice';

type OwnProps = {
  children: React.ReactNode;
  collapsed: boolean;
  onCollapse: () => void;
  companyId?: number;
};

type ComponentProps = OwnProps;

const DOMAIN = getDomainAndPort().protocolDomain;

const Sidebar: React.FC<ComponentProps> = ({
  children,
  collapsed,
  onCollapse,
  companyId,
}: ComponentProps) => {
  const { t } = useTranslation('general');
  const user = useSelector((store: RootState) => {
    return store.thisUser;
  });

  const [currentCompanySmsInfo, setCurrentCompanySmsInfo] =
    useState<IClientItem | null>(null);

  const { setIsOpen } = useTour();

  const handleGetSmsInfo = async () => {
    try {
      const res = await axios.get(`${DOMAIN}/man/rest/company/smsInfo`, {
        headers: { Authorization: user.access_token },
        params: { companyId },
      });
      if (res?.data) setCurrentCompanySmsInfo(res.data);
    } catch (ignored) {
      /*do nothing*/
    }
  };

  useEffect(() => {
    setIsOpen(true);
  }, []);

  useEffect(() => {
    handleGetSmsInfo();
  }, [companyId]);

  return (
    <SidebarWrapper collapsed={collapsed}>
      <BurgerMenu onClick={onCollapse} isOpen={!collapsed}>
        <div></div>
        <div></div>
        <div></div>
      </BurgerMenu>
      {!collapsed && user && (
        <MoreAboutCompany>
          <NavLink path="/homepage">
            <Icon type={'repeat'} title={t('changeCompanies')} />
          </NavLink>
        </MoreAboutCompany>
      )}
      {!collapsed && (
        <>
          <SidebarContext.Provider value={collapsed}>
            {children}
          </SidebarContext.Provider>
          {currentCompanySmsInfo?.balanceCheck && (
            <EmptyArea>
              <div className={'font-bold'}>{t('currentBalance')}: </div>
              <div>
                {(currentCompanySmsInfo?.balanceIRR || 0) > 0
                  ? currentCompanySmsInfo!.balanceIRR + ' ' + t('IRR')
                  : t('endedCharge')}
              </div>
            </EmptyArea>
          )}
          {user && user.isLoggedIn ? (
            <ProfileDropDownHeader isCollapsed={collapsed}>
              <BadgeProfileDropdown
                direction={'left'}
                user={user}
                companyId={companyId}
                isHidden={collapsed}
                enableMobileViewMode={false}
                isThemeEnabled={true}
              />
            </ProfileDropDownHeader>
          ) : (
            <MenuLink
              path={getRedirectToLoginPath()}
              style={{ marginBottom: '0.5rem' }}
            >
              <MenuItem>
                <Icon type="log-in" />
                {t('login', { ns: 'mainNavBar' })}
              </MenuItem>
            </MenuLink>
            // <HeaderItem>
            //   <Link to={getRedirectToLoginPath()}>{messages.login}</Link>
            // </HeaderItem>
          )}
        </>
      )}
    </SidebarWrapper>
  );
};

export default Sidebar;
